import React, { useEffect, useState } from "react";
import PageTitle from "../../../../components/pageTitle/PageTitle";
import { Grid } from "@mui/material";
import { BLINK_DETAILS_FIELDS } from "./bookAllFields";
import FormField from "../../../../components/common/FormField";
import { useDispatch, useSelector } from "react-redux";
import {
  getBlinkDetails,
  initialBlinkState,
  setAddBlinkResponse,
  setUpdateBlinkResponse,
} from "../../../../store/reducers/quickBookSlice";
import { setNotificationAction } from "../../../../store/reducers/mmymSlice";
import ManageBlink from "./ManageBlink";

const BlinkDetails = () => {
  const dispatch = useDispatch();
  const { singleBlink, isBlinkAdded, isBlinkUpdated } = useSelector(
    (state: any) => state?.quickBook,
  );
  const [formData, setFormData] = useState<any>(initialBlinkState);
  const [open, setOpen] = useState(false);
  const onChangeAction = (event: React.ChangeEvent<HTMLInputElement>) => {
    const { id, value } = event.target;
    setFormData((prevState: any) => ({
      ...prevState,
      [id]: value,
    }));
  };
console.log("singleBlink",singleBlink);
  useEffect(() => {
    if (isBlinkAdded || isBlinkUpdated) {
      dispatch(getBlinkDetails());
      dispatch(setAddBlinkResponse(false));
      dispatch(setUpdateBlinkResponse(false));
    }
  }, [dispatch, isBlinkAdded, isBlinkUpdated]);
  const handleOpen = () => {
    setOpen(true);
    dispatch(setNotificationAction({ message: [], severity: "error" }));
  };

  const handleSelectedModel = () => {};

  return (
    <>
      {open && (
        <ManageBlink
          open={open}
          onHide={() => setOpen(false)}
          title={singleBlink?.apiKey ? "Edit Blink" : "Add Blink"}
          selectData={singleBlink}
        />
      )}

      <div style={{ marginTop: "20px" }}>
        <PageTitle
          title="Blink Details"
          button={singleBlink?.apiKey && singleBlink?.is_editable ? "Edit" : singleBlink?.is_editable ? "Add" : ""}
          onClick={handleOpen}
        />
        <Grid
          container
          spacing={2}
          sx={{
            padding: "10px",
            mt: 1,
            background: "#E5F4F1",
            borderRadius: "5px",
            border: "1px solid #CFCFCF",
          }}
        >
          <Grid
            item
            md={12}
            xs={12}
            sx={{ paddingLeft: "0px !important", paddingRight: "16px" }}
          >
            <Grid container spacing={0.5}>
              {/* <Grid item md={12} xs={12} sx={{ mb: 2 }}>
                <Typography variant="h5" sx={{ fontWeight: "600" }}>
                  {userProfile?.AccountingSoftware
                    ? userProfile?.AccountingSoftware
                    : ""}{" "}
                  Details
                </Typography>
              </Grid> */}
              {BLINK_DETAILS_FIELDS &&
                BLINK_DETAILS_FIELDS.map((field) => (
                  <FormField
                    key={field.id}
                    // onPaste={(e) => e.preventDefault()}

                    {...{
                      ...field,
                      value: singleBlink ? singleBlink[field.id] || "" : "",
                      variant: "outlined",
                      isNonMarginTop: true,
                      inSingleGridForm: true,
                      onChange: onChangeAction,
                      disabled: true,
                      maxLength: 250,
                      blurFilter:
                        field?.id === "apiKey" ||
                        field?.id === "secretKey"
                          ? true
                          : false,
                      InputProps: {
                        sx:
                          field?.type === "text" || field?.type === "password"
                            ? { height: "30px" }
                            : {
                                padding: "6px 12px",
                                // height: "36px",
                              },
                      },
                    }}
                  />
                ))}
            </Grid>
          </Grid>
        </Grid>
      </div>
    </>
  );
};

export default BlinkDetails;
